module.exports = {
	hg18: require('./data/chromInfo_hg18.json'),
	hg19: require('./data/chromInfo_hg19.json'),
	GRCh37: require('./data/chromInfo_hg19.json'),
	hg38: require('./data/chromInfo_hg38.json'),
	GRCh38: require('./data/chromInfo_hg38.json')
};
